import React from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'

import Checkbox from 'components/Checkbox'

const SelectableItem = ({ checked, handleChange, label }) => {
  return (
    <div className="selectable-items__item">
      <Checkbox
        checked={checked}
        onChange={handleChange}
        label={label}
        className={cn({ '-checked': checked })}
      />
    </div>
  )
}

SelectableItem.propTypes = {
  checked: PropTypes.bool,
  handleChange: PropTypes.func,
  label: PropTypes.node,
}

export default SelectableItem
